/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// actions and reducers used to manipulate application state
import { getClientEmbedsData } from 'state/actions/embedsState/embeds_status';
import { resetEmbedState } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { resetContentState } from 'state/actions/embedsState/embedManagementState/content_status';
import { updatePageDetails, changePage } from 'state/actions/app_status';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import Embeds from 'pages/dashboard/embeds/embeds';
import {batchActions} from "redux-batched-actions/lib/index";



/* ========== ~~~~~~~~~~ EMBEDS: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ appStatus, embedsState, sessionStatus }) => ({
    currentPage: appStatus.currentPage,
    embedName: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedName,
    embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID,
    accountUUID: sessionStatus.accountUUID,
    isDataReceived: embedsState.embedsStatus.isDataReceived,
    clientEmbeds: embedsState.embedsStatus.clientEmbeds,
    editPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('manageEmbeds'),
    permissionsReceived: sessionStatus.permissionsReceived
});
// map actions
const mapDispatchToProps = dispatch => ({
    getClientEmbedsData: accountUUID => dispatch(getClientEmbedsData(accountUUID)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    moveToEmbedCreationWithStateReset: () => {
        dispatch(batchActions([
            resetEmbedState(),
            resetContentState({ setInitialContentId: true }),
        ]));
        dispatch(updatePageDetails(`dashboard/embeds/management/getstarted`));
        dispatch(updateStepDetails('getstarted'));
        dispatch(changePage(`dashboard/embeds/management/getstarted`))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Embeds));
